import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useOrders } from '../contexts/OrderContext';
import { Order } from '../types';
import { Card } from '../components/ui/Card';
import { StatusBadge } from '../components/ui/StatusBadge';
import { Button } from '../components/ui/Button';
import { OrderTimeline } from '../components/OrderTimeline';
import { ArrowLeft, MapPin, Phone, Calendar, Package } from 'lucide-react';
export function OrderDetailPage() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    orders
  } = useOrders();
  const [order, setOrder] = useState<Order | null>(null);
  useEffect(() => {
    if (id) {
      const found = orders.find(o => o.id === id);
      setOrder(found || null);
    }
  }, [id, orders]);
  if (!order) {
    return <div className="text-center py-12" data-id="element-546">
        <p className="text-gray-500" data-id="element-547">Commande introuvable</p>
        <Button variant="ghost" onClick={() => navigate(-1)} className="mt-4" data-id="element-548">
          Retour
        </Button>
      </div>;
  }
  return <div className="space-y-6 max-w-4xl mx-auto" data-id="element-549">
      <div className="flex items-center justify-between" data-id="element-550">
        <div className="flex items-center" data-id="element-551">
          <Button variant="ghost" onClick={() => navigate(-1)} className="mr-2 pl-0" data-id="element-552">
            <ArrowLeft className="w-5 h-5" data-id="element-553" />
          </Button>
          <div data-id="element-554">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-555">
              Commande {order.id}
            </h1>
            <p className="text-sm text-gray-500" data-id="element-556">
              Créée le {new Date(order.createdAt).toLocaleDateString('fr-FR')}
            </p>
          </div>
        </div>
        <StatusBadge status={order.status} className="text-sm px-3 py-1" data-id="element-557" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-558">
        {/* Main Info */}
        <div className="md:col-span-2 space-y-6" data-id="element-559">
          <Card title="Informations Client" data-id="element-560">
            <div className="space-y-4" data-id="element-561">
              <div className="flex items-start" data-id="element-562">
                <div className="flex-shrink-0 mt-1" data-id="element-563">
                  <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold text-lg" data-id="element-564">
                    {order.clientName.charAt(0)}
                  </div>
                </div>
                <div className="ml-4" data-id="element-565">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-566">
                    {order.clientName}
                  </h3>
                  <div className="mt-1 flex items-center text-gray-500" data-id="element-567">
                    <Phone className="w-4 h-4 mr-2" data-id="element-568" />
                    {order.clientPhone}
                  </div>
                  <div className="mt-1 flex items-center text-gray-500" data-id="element-569">
                    <MapPin className="w-4 h-4 mr-2" data-id="element-570" />
                    {order.address}
                  </div>
                  <div className="mt-1 ml-6 text-sm text-gray-400" data-id="element-571">
                    Zone: {order.zone}
                  </div>
                </div>
              </div>
            </div>
          </Card>

          <Card title="Détails Commande" data-id="element-572">
            <div className="grid grid-cols-2 gap-4" data-id="element-573">
              <div data-id="element-574">
                <p className="text-sm text-gray-500 mb-1" data-id="element-575">Type</p>
                <div className="flex items-center font-medium" data-id="element-576">
                  <Package className="w-4 h-4 mr-2 text-gray-400" data-id="element-577" />
                  {order.type}
                </div>
              </div>
              <div data-id="element-578">
                <p className="text-sm text-gray-500 mb-1" data-id="element-579">Quantité</p>
                <p className="font-medium text-xl" data-id="element-580">{order.quantity}</p>
              </div>
              <div data-id="element-581">
                <p className="text-sm text-gray-500 mb-1" data-id="element-582">Livraison Estimée</p>
                <div className="flex items-center font-medium" data-id="element-583">
                  <Calendar className="w-4 h-4 mr-2 text-gray-400" data-id="element-584" />
                  {new Date(order.estimatedDeliveryDate).toLocaleDateString('fr-FR')}
                </div>
              </div>
              {order.storageLocation && <div data-id="element-585">
                  <p className="text-sm text-gray-500 mb-1" data-id="element-586">
                    Emplacement Stockage
                  </p>
                  <p className="font-medium text-purple-600" data-id="element-587">
                    {order.storageLocation.zone} - {order.storageLocation.shelf}
                  </p>
                </div>}
            </div>
            {order.notes && <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-588">
                <p className="text-sm text-gray-500 mb-1" data-id="element-589">Notes</p>
                <p className="text-sm bg-yellow-50 p-3 rounded text-yellow-800 border border-yellow-100" data-id="element-590">
                  {order.notes}
                </p>
              </div>}
          </Card>
        </div>

        {/* Timeline Sidebar */}
        <div className="md:col-span-1" data-id="element-591">
          <Card title="Historique" className="h-full" data-id="element-592">
            <OrderTimeline timeline={order.timeline} data-id="element-593" />
          </Card>
        </div>
      </div>
    </div>;
}